'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Radio = function Radio(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none"
  }), React__default["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "18",
    height: "18",
    rx: "8.5"
  }), React__default["default"].createElement("rect", {
    x: "5",
    y: "5",
    width: "8",
    height: "8",
    rx: "4",
    stroke: "transparent",
    fill: "transparent"
  }));
};

var Radio$1 = iconStyles()(Radio);

module.exports = Radio$1;
